export default __webpack_public_path__ + "static/media/included-vc-logo.65b8de91.png";